<template>
  <PageContent :loading="loading" :top-sticked="true">
    <Container>
      <ul class="list-group">
        <ReservedEventRow
          v-for="event in events"
          :key="`event_${event.event_id}`"
          :event="event"
          @cancel="onCancelConfirm"
        />
      </ul>

      <Modal
        id="confirm-cancel-reservation"
        title="予約をキャンセルしてよろしいですか？"
        icon="exclamation"
        type="danger"
      >
        <template #footer>
          <WaveButton
            type="button"
            size="small"
            :text="true"
            :gray="true"
            @click="$modal.close('confirm-cancel-reservation')"
          >キャンセル</WaveButton>
          <WaveButton
            type="button"
            size="small"
            :text="true"
            :danger="true"
            @click="onCancel"
            :disabled="submitDisabled"
          >OK</WaveButton>
        </template>
      </Modal>
    </Container>
  </PageContent>
</template>

<script>
import Modal from '@/components/Modal'
import ReservedEventRow from '@/components/ReservedEventRow'
import { renderError } from '@/utils/error'
import eventApi from '@/api/event'

export default {
  components: {
    Modal,
    ReservedEventRow
  },

  props: {
    reservedEvents: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      events: [],
      cancelTarget: null,
      submitDisabled: false
    }
  },

  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    }
  },

  methods: {
    onCancelConfirm(eventId, callback) {
      this.$modal.show('confirm-cancel-reservation', {
        onClose: () => {
          this.cancelTarget = null
          callback()
        }
      })

      this.cancelTarget = this.selectedEvent(eventId)
    },
    async onCancel() {
      if (this.cancelTarget === null) {
        return false
      }

      this.submitDisabled = true

      try {
        const data = {
          event_revision: this.cancelTarget.event_revision,
          reserve_revision: this.cancelTarget.reserve_revision
        }

        const response = await eventApi.cancel(
          this.businessId,
          this.cancelTarget.event_id,
          data
        )

        this.cancelTarget.event_revision = response.event_revision
        this.cancelTarget.reserve_revision = response.reserve_revision

        this.deleteEvent(this.cancelTarget.event_id)

        this.$emit('canceled')
      } catch(err) {
        renderError(err)
      } finally {
        this.$modal.close('confirm-cancel-reservation')
        this.submitDisabled = false
      }
    },
    selectedEvent(eventId) {
      return this.events.find(({ event_id }) => event_id === eventId)
    },
    deleteEvent(eventId) {
      this.events = this.events.filter(
        event => event.event_id !== eventId
      )
    },
  },

  watch: {
    reservedEvents() {
      this.$nextTick(() => {
        this.events = this.reservedEvents
      })
    }
  }
}
</script>
